<template lang="html">
<!--        上传材料模块 -->
    <cc-preview-module title="上传材料" class="fd-preview-sccl-module">
        <ac-preview-file
            title="复议申请书"
            :data="scclData.sqs"></ac-preview-file>
        <!--        子集模块 -->
        <div class="fd-sccl-module-child">
            <!--        身份证明材料-->
            <h5 class="fd-sccl-module-child-tit">身份证明材料</h5>
            <ac-preview-file
                class="fd-sccl-module-child-upload"
                v-for="item in scclData.sfzml"
                :key="item.ryid"
                :title="item.rymc"
                :data="item.clList"></ac-preview-file>
        </div>
        <ac-preview-file
            title="复议证据材料"
            :data="scclData.zjl"></ac-preview-file>
        <ac-preview-file
            title="保全裁定书"
            :data="scclData.fycds"></ac-preview-file>
        <ac-preview-file
            title="其他材料"
            :data="scclData.qt"></ac-preview-file>
    </cc-preview-module>
</template>

<script>
    // 模块预览组件
    import ccPreviewModule from '@/components/common/preview-module/index.vue';
    // 预览文件
    import acPreviewFile from '@/components/app/preview-file/index.vue';
    // 请求混入js
    import request from '../mixins/request.js';

    export default {
        mixins: [request],
        components: {
            ccPreviewModule,
            acPreviewFile
        },
        // 注入
        inject: ['fyid'],
        data() {
            return {
                // 上传材料
                scclData: {}
            }
        },
        methods: {
            getCcxsList() {
                // 请求上传材料数据
                this.requestScclData(this.fyid).then(scclData => {
                    this.scclData = scclData;
                })
            }
        },
        mounted() {
            this.getCcxsList()
        }
    }
</script>
